module.exports = __webpack_public_path__ + "img/Retention-risks@2x.1c6129b1.png";